import React from 'react';
import PropTypes from 'prop-types';
import { startCase } from 'lodash';
import Badge from '../../../ReusableComponents/Badge/Badge';

export default function AuditStatusTableBadge({ status }) {
  const colorStatus = {
    Passed: 'green',
    Failed: 'red',
    Failure: 'red',
    Pending: 'yellow',
    'Not Started': 'gray',
  };
  const label = startCase(status);

  if (label) {
    return (
      <Badge
        color={colorStatus[status || 'gray']}
        label={startCase(status) || status}
      />
    );
  }
  return '-';
}

AuditStatusTableBadge.propTypes = {
  status: PropTypes.string.isRequired,
};
